import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { CorrectiveActionsGrid, ServiceThreadSpinner } from '.';
import { api, constants } from '../utils';

export default function VendorCorrectiveActions({ vendorId, vendorName }) {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState({ field: "createdDate", direction: "desc" });
  const [totalPages, setTotalPages] = useState(null)
  const [working, setWorking] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(refreshData, [vendorId, page, sort])

  function createPayload() {
    return {
      vendorId: vendorId,
      actionType: constants.CORRECTIVE_ACTION_TYPES.SupplierAction,
      actionStatus: 0,
      problemType: 0,
      calledFromSalesDashboard: false,
      includeInternal: false,
      pageNumber: page,
      pageSize: 10,
      sortField: sort.field,
      sortDirection: sort.direction,
    }
  }

  function onSortChange(field, direction) {
    if (field !== sort.field) {
      setSort({ field: field, direction: "asc" });
    } else {
      setSort({ ...sort, direction: direction })
    }
    setPage(1);
  }

  function refreshData() {
    setWorking(true);
    api
      .post('Quality/GetPaginatedCorrectiveActions', createPayload())
      .then(r => {
        if (r.data.success) {
          setData(r.data.correctiveActions.items)
          setTotalPages(_.ceil(r.data.correctiveActions.totalCount / 10));
        } else {
          console.error(r.data.message)
        }
      })
      .catch(api.catchHandler)
      .finally(() => setWorking(false));
  }

  return (
    <>
      <div>
        <span className="h2 me-2">Corrective Action History</span>{' '}
        <span className="text-muted">Vendor {vendorId}</span>
      </div>
      <hr />
      <ServiceThreadSpinner on={working}>
        {data && data.length
          ? <CorrectiveActionsGrid
            data={data}
            sortCallback={onSortChange}
            sortField={sort.field}
            sortDirection={sort.direction}
            pagerCallback={setPage}
            pageNumber={page}
            totalPages={totalPages}
          />
          : <span className="h5">No Corrective Actions found</span>}
      </ServiceThreadSpinner>
    </>
  );
}